<template>
  <validation-observer
    ref="form"
    v-slot="{ passes, invalid }"
  >
    <b-form
      v-bind="$attrs"
      @submit.prevent="passes(onSubmit)"
    >
      <slot
        name="form" 
        :invalid="invalid"
      />
      <slot
        name="buttons"
        :invalid="invalid"
      />
    </b-form>
  </validation-observer>
</template>

<script>
import { ValidationObserver } from 'vee-validate';

export default {
  name: 'ValidatedForm',
  components: {ValidationObserver},
  props: {
    submit: {
      type: Function,
      default: () => {}
    }
  },
  methods: {
    onSubmit() {
      this.submit();

      this.$nextTick(() => {
        this.$refs.form.reset();
      });
    },
    validate() {
      this.$refs.form.observer.validate();
    }
  }
};
</script>

<style scoped>

</style>
